import { Component, OnDestroy, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { PageTitleComponent } from '@howdeniberia/core-front';
import { ClientsSearchDialogComponent, IClientDto } from 'clients-search-lib';
import { SubSink } from 'subsink';

@Component({
  selector: 'howden-search-button',
  templateUrl: './search-button.component.html',
  styleUrls: ['./search-button.component.scss'],
  imports: [
    PageTitleComponent,
    MatIcon,
    MatButton
  ]
})
export class SearchButtonComponent implements OnDestroy {
  private dialog = inject(MatDialog);

  private _subscriptions = new SubSink();

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  openClientsSearchDialog() {
    const dialogRef = this.dialog.open(ClientsSearchDialogComponent, {
      height: '95%',
      width: '95%',
      maxHeight: '720px'
    });

    this._subscriptions.sink = dialogRef.afterClosed().subscribe((selectedClient: IClientDto | null) => {
      if (selectedClient !== null) {
        this.clientSelected(selectedClient);
      }
    });
  }

  clientSelected(client: IClientDto) {
    alert(client ? client.fullName : 'no hay cliente');
  }
}
